import { MIN_MAX_AGE } from '@atlassian/jira-router-resources-utils/src/constants.tsx';
import { createResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_PROJECTS_COMPONENTS } from '../constants.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const projectsComponentsResource = createResource<any>({
	type: RESOURCE_TYPE_PROJECTS_COMPONENTS,
	getKey: () => 'state',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-projects-components", jiraSpaEntry: "async-resource-projects-components" */ './get-data'
		),
	maxAge: MIN_MAX_AGE,
});
